var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTotalNumberOfSavers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.7072 7.82568C17.6382 7.81581 17.5691 7.81581 17.5 7.82568C15.9704 7.77633 14.7566 6.52304 14.7566 4.98356C14.7566 3.41449 16.0296 2.13159 17.6085 2.13159C19.1776 2.13159 20.4605 3.40462 20.4605 4.98356C20.4507 6.52304 19.2368 7.77633 17.7072 7.82568Z",
    fill: "#220075"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9243 14.6645C19.8191 15.4047 18.2697 15.681 16.8388 15.4935C17.2138 14.6843 17.4112 13.7862 17.4211 12.8389C17.4211 11.852 17.2039 10.9145 16.7895 10.0955C18.25 9.89809 19.7993 10.1744 20.9145 10.9145C22.4737 11.9408 22.4737 13.6283 20.9243 14.6645Z",
    fill: "#220075"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.76316 7.82568C6.83224 7.81581 6.90132 7.81581 6.9704 7.82568C8.5 7.77633 9.71382 6.52304 9.71382 4.98356C9.71382 3.41449 8.44079 2.13159 6.86185 2.13159C5.29277 2.13159 4.00987 3.40462 4.00987 4.98356C4.01974 6.52304 5.23355 7.77633 6.76316 7.82568Z",
    fill: "#220075"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.87171 12.8388C6.87171 13.796 7.07895 14.7039 7.45395 15.523C6.0625 15.671 4.61185 15.3749 3.54606 14.6743C1.98685 13.6381 1.98685 11.9506 3.54606 10.9144C4.60198 10.2039 6.09211 9.91771 7.49342 10.0756C7.08882 10.9046 6.87171 11.8421 6.87171 12.8388Z",
    fill: "#220075"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3684 15.8191C12.2895 15.8092 12.2007 15.8092 12.1118 15.8191C10.2961 15.7599 8.8454 14.2698 8.8454 12.4342C8.8454 10.5592 10.3553 9.03949 12.2401 9.03949C14.1151 9.03949 15.6349 10.5592 15.6349 12.4342C15.6349 14.2698 14.1941 15.7599 12.3684 15.8191Z",
    fill: "#220075"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.16119 17.8618C7.67106 18.8585 7.67106 20.4967 9.16119 21.4835C10.8586 22.6184 13.6415 22.6184 15.3388 21.4835C16.829 20.4868 16.829 18.8487 15.3388 17.8618C13.6513 16.727 10.8684 16.727 9.16119 17.8618Z",
    fill: "#220075"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalNumberOfSavers);
export default __webpack_public_path__ + "static/media/total-number-of-savers.dcc20695.svg";
export { ForwardRef as ReactComponent };